module.exports = __webpack_public_path__ + "img/Estrellita.svg.7fa1be7d.webp";